import React, { useContext, useEffect, useState } from "react";
import { UserContext } from "../../shared/context/userContext";
import {
  TermsAndConditionsContainer,
  TermsAndConditionsLink,
} from "./TermsAndConditions.styles";
import { TERMS_AND_CONDITIONS_KEY, TERMS_AND_CONDITIONS_URL } from "../../shared/utils/valueConstants";
import { Fade } from "@material-ui/core";

export const TermsAndConditionsWrapper = () => {
  const user = useContext(UserContext);
  const [visible, setVisible] = useState<boolean>(true);
  const [shown, setShown] = useState<boolean>(true);

  useEffect(() => {
    if (user.userData.authState === "signedIn") {
      const hasAcknowledged =
        localStorage.getItem(TERMS_AND_CONDITIONS_KEY) === "true";

      setVisible(!hasAcknowledged);
      setShown(!hasAcknowledged);
    } else {
      setVisible(false);
      setShown(false);
    }
  }, [user.userData.authState]);

  const dismiss = () => {
    localStorage.setItem(TERMS_AND_CONDITIONS_KEY, "true");

    setVisible(false);
  };

  if (user.userData.authState === "signedIn" && shown)
    return (
      <Fade in={visible} onExited={() => setShown(false)}>
        <TermsAndConditionsContainer onClick={dismiss}>
          Please read the latest Terms & Conditions{" "}
          <TermsAndConditionsLink
            href={process.env.REACT_APP_TERMS_AND_CONDITIONS ?? TERMS_AND_CONDITIONS_URL}
            target="_blank"
          >
            here.
          </TermsAndConditionsLink>
        </TermsAndConditionsContainer>
      </Fade>
    );
  else return null;
};
